import Vue from "vue";
import ResourceService from "./resource.service";

class DriverService extends ResourceService {
  static get resource() {
    return "driver";
  }

  static ratingDetails(driverID, rateNumber, params = {}) {
    const url = `${this.resource}/${driverID}/rating-details/${rateNumber}`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static rating(driverID) {
    const url = `${this.resource}/${driverID}/rating`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static download(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download`, {
          responseType: "blob",
          params
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static upload(formData) {
    const url = `${this.resource}/import-drivers`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  }
}

export default DriverService;
